import React, { useState, useMemo, useEffect } from "react";
import {
    Card,
    CardBody,
    Col
} from "reactstrap";
import ReactTableGeneric from "Components/ReactTableGeneric";
import { ReactComponent as DownloadIcon } from "../../../../../assets/utils/images/svgs/downloadCircleDarlBlue.svg";
import { ReactComponent as PendingIcon } from "../../../../../assets/utils/images/svgs/HistoryclockionDarkBlue.svg";
import Loader from "react-loaders";
import { IoIosRefresh } from "react-icons/io";
import TitleModal from "Components/Modal/InfoModal/TitleModal";

import { useExportList, useSaveExportHistory } from "Api/Coordinator/Beheer/Exporten";
import { downloadBase64File } from "helperFunctions";

function ExportTable({ exportData, setExportData, fetchHistoryData, isLoading, selectedOrganization, intervalRef }) {

    const processingRowIds = useMemo(
        () =>
            exportData
                ?.filter(
                    item =>
                        item.rowStatus === "in-progress" ||
                        item.rowStatus === "failed"
                )
                .map(item => item.id) || [],
        [exportData]
    );

    const {
        trigger: getExportList,
        isMutating: exportLoading,
    } = useExportList();


    useEffect(() => {
        if (!processingRowIds.length) return;

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(() => {
            getExportList({
                data: {
                    communityId: selectedOrganization,
                    ...(processingRowIds?.length && {
                        iExportId: processingRowIds
                    })
                }
            }).then((response) => {
                if (response?.data?.exportLists) {
                    setExportData(prev =>
                        prev.map(item => {
                            const updated =
                                response?.data.exportLists.find(
                                    e => e.id === item.id
                                );

                            return updated || item;
                        })
                    );
                }
            });
        }, 15000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [processingRowIds]);

    const {
        trigger: saveExportHistory,
        isMutating: downloadLoading
    } = useSaveExportHistory();

    const handleDownload = (data) => {
        if (!data) return;

        saveExportHistory({
            data: {
                iExportId: data.id,
                iCommunityId: selectedOrganization,
            },
        })
            .then((response) => {
                const fileData = response?.data;
                const fileType = response?.type || "xlsx";

                if (fileData) {
                    downloadBase64File(
                        fileData,
                        `export_${data.id}.${fileType}`
                    );
                }

                fetchHistoryData();
            })
            .catch((error) => {
                console.error("Download failed", error);
            });
    };

   const exportColumn = useMemo(() => (
    [
        { header: "Export ID",    accessorKey: "id" },
        { header: "Bestuur",      accessorKey: "vCommunityName" },
        { header: "Coördinator",  accessorKey: "coordinatorName" },
        { header: "Type",         accessorKey: "type" },
        { header: "Aanmaakdatum", accessorKey: "Created_At" },
        {
            header: "Filters",
            accessorKey: "filters",
            cell: ({ row }) => (
                <div className="d-flex justify-content-center overig-exporteren-filter">
                    <TitleModal data={row.original.filters || ''} />
                </div>
            )
        },
        {
            header: "Status",
            accessorKey: "iStatus",
            cell: ({ row }) => {
                const text = row.original.iStatus === 0
                    ? "Wordt aangemaakt..."
                    : row.original.iStatus === 1
                        ? `Export nog ${row.original.Days_left > 1 ? row.original.Days_left + ' dagen' : '1 dag'} beschikbaar`
                        : "Is verlopen...";
                return <div><span key={text}>{text}</span></div>;
            }
        },
        {
            header: "Download",
            accessorKey: "download",
            cell: ({ row }) => (
                <div className="d-flex justify-content-center">
                    {(row.original.rowStatus === "in-progress" || row.original.rowStatus === "failed")
                        ? (exportLoading ? <IoIosRefresh className="spin" color="#025F94" /> : <PendingIcon />)
                        : (row.original.rowStatus === "completed" && row.original.convertedFile !== null)
                            ? <DownloadIcon className="cursor-pointer" onClick={() => handleDownload(row.original)} />
                            : <PendingIcon />
                    }
                </div>
            )
        },
    ]
), [exportLoading]);

    return (<Col sm={12}>
        <div className="row">
            <div className="col">
                <Card className="main-card mb-3">
                    <CardBody className="p-3">
                        {isLoading ? <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} /> :
                            <>
                                <div className="d-flex justify-content-between  ">
                                    <div className="btn-color-style travelCost-blue-text mb-2">Download</div>
                                </div>
                                <ReactTableGeneric
                                    key={exportData.length}
                                    data={exportData || []}
                                    columns={exportColumn}
                                    tableClassName="mb-0 table table-borderless table-sm table-hover wtf-table download-table"
                                    filters={{
                                        search: false,
                                        sorting: false,
                                        pagination: false
                                    }}
                                    rowCount={exportData.length}
                                /></>}
                    </CardBody>
                </Card>
            </div>
        </div>
    </Col>)
}

export default ExportTable;